<div
  class="phone-input-wrapper"
  [class.error]="
    (this.isFormSubmitted || this.control?.touched) && this.control?.errors
  "
>
  <div class="country-code-select">
    <nz-select
      nzShowSearch
      nzPlaceHolder="Select Country"
      [(ngModel)]="countrycodeid"
      [nzCustomTemplate]="defaultTemplate"
      (ngModelChange)="onCountryChange($event, true)"
      class="font-16"
      [nzDropdownClassName]="'common-dropdown-menu'"
    >
      @for (country of countrylist; track country.id) {
        <nz-option
          nzCustomContent
          nzLabel="{{ country.phone_code + ' - ' + country.country }}"
          nzValue="{{ country.id }}"
        >
          <img src="{{ country.logo }}" alt="" class="country-icon" />
          <span class="countrycode">{{
            country.phone_code + " - " + country.country
          }}</span>
        </nz-option>
      }
    </nz-select>
    <ng-template #defaultTemplate let-selected>
      <img [src]="selectedCountry?.logo" alt="" class="country-icon" />
      <span class="mx-2 countrycode">{{ selectedCountry?.phone_code }}</span>
    </ng-template>
  </div>

  <input
    type="text"
    [placeholder]="getPlaceholder()"
    [formControl]="control"
    [minlength]="min"
    [maxlength]="max"
    [readonly]="readonly"
    OnlyNumeric
    class="phone-input"
  />
</div>
